export const userData = [
  {
    id: 1,
    name: "Aman Gupta",
    role: "Accountant & Finance",
    roleId: 2,
  },
  {
    id: 2,
    name: "Deepak Sharma",
    role: "Sales",
    roleId: 4,
  },
  {
    id: 3,
    name: "Avhinav Dhingra",
    role: "Operation",
    roleId: 3,
  },
  {
    id: 4,
    name: "Rajiv Mehta",
    role: "Maintenance",
    roleId: 1,
  },
  {
    id: 5,
    name: "Rajiv Mehta",
    role: "Stakes",
    roleId: 6,
  },
  {
    id: 6,
    name: "Rajdeep Dutta",
    role: "Research & Development",
    roleId: 5,
  },
  {
    id: 7,
    name: "Sonia Verma",
    role: "Accountant & Finance",
    roleId: 2,
  },
  {
    id: 8,
    name: "Vikram Singh",
    role: "Sales",
    roleId: 4,
  },
  {
    id: 9,
    name: "Neha Patel",
    role: "Operation",
    roleId: 3,
  },
  {
    id: 10,
    name: "Ankit Kapoor",
    role: "Maintenance",
    roleId: 1,
  },
  {
    id: 11,
    name: "Kavita Shah",
    role: "Stakes",
    roleId: 6,
  },
  {
    id: 12,
    name: "Rohit Singh",
    role: "Research & Development",
    roleId: 5,
  },
  {
    id: 13,
    name: "Priya Agarwal",
    role: "Human Resources",
    roleId: 7,
  },
  {
    id: 14,
    name: "Amit Trivedi",
    role: "Marketing",
    roleId: 8,
  },
  {
    id: 15,
    name: "Sara Khan",
    role: "Customer Support",
    roleId: 9,
  },
  {
    id: 16,
    name: "Amit Gupta",
    role: "Accountant & Finance",
    roleId: 2,
  },
  {
    id: 17,
    name: "Neha Sharma",
    role: "Sales",
    roleId: 4,
  },
  {
    id: 18,
    name: "Rahul Verma",
    role: "Operation",
    roleId: 3,
  },
  {
    id: 19,
    name: "Meera Kapoor",
    role: "Maintenance",
    roleId: 1,
  },
  {
    id: 20,
    name: "Rajesh Khanna",
    role: "Stakes",
    roleId: 6,
  },
  {
    id: 21,
    name: "Sonia Dutta",
    role: "Research & Development",
    roleId: 5,
  },
  {
    id: 22,
    name: "Alok Gupta",
    role: "Human Resources",
    roleId: 7,
  },
  {
    id: 23,
    name: "Preeti Singh",
    role: "Marketing",
    roleId: 8,
  },
  {
    id: 24,
    name: "Anuj Kumar",
    role: "Customer Support",
    roleId: 9,
  },
  {
    id: 25,
    name: "Deepa Patel",
    role: "IT Support",
    roleId: 10,
  },
  {
    id: 26,
    name: "Vishal Kapoor",
    role: "Legal",
    roleId: 11,
  },
  {
    id: 27,
    name: "Asha Singh",
    role: "Quality Assurance",
    roleId: 12,
  },
  {
    id: 28,
    name: "Rajeev Sharma",
    role: "Logistics",
    roleId: 13,
  },
  {
    id: 29,
    name: "Kavita Trivedi",
    role: "Public Relations",
    roleId: 14,
  },
  {
    id: 30,
    name: "Alok Singh",
    role: "Training and Development",
    roleId: 15,
  },
  {
    id: 31,
    name: "Pooja Kapoor",
    role: "Accountant & Finance",
    roleId: 2,
  },
  {
    id: 32,
    name: "Rohit Verma",
    role: "Sales",
    roleId: 4,
  },
  {
    id: 33,
    name: "Sanjay Mehta",
    role: "Operation",
    roleId: 3,
  },
  {
    id: 34,
    name: "Nisha Khanna",
    role: "Maintenance",
    roleId: 1,
  },
  {
    id: 35,
    name: "Varun Dutta",
    role: "Stakes",
    roleId: 6,
  },
  {
    id: 36,
    name: "Sapna Gupta",
    role: "Research & Development",
    roleId: 5,
  },
  {
    id: 37,
    name: "Vikas Sharma",
    role: "Human Resources",
    roleId: 7,
  },
  {
    id: 38,
    name: "Ritu Verma",
    role: "Marketing",
    roleId: 8,
  },
  {
    id: 39,
    name: "Manish Singh",
    role: "Customer Support",
    roleId: 9,
  },
  {
    id: 40,
    name: "Neha Patel",
    role: "IT Support",
    roleId: 10,
  },
  {
    id: 41,
    name: "Anil Kapoor",
    role: "Legal",
    roleId: 11,
  },
  {
    id: 42,
    name: "Priya Dutta",
    role: "Quality Assurance",
    roleId: 12,
  },
  {
    id: 43,
    name: "Rahul Sharma",
    role: "Logistics",
    roleId: 13,
  },
  {
    id: 44,
    name: "Sneha Trivedi",
    role: "Public Relations",
    roleId: 14,
  },
  {
    id: 45,
    name: "Anita Singh",
    role: "Training and Development",
    roleId: 15,
  },
  {
    id: 46,
    name: "Amit Trivedi",
    role: "Accountant & Finance",
    roleId: 2,
  },
  {
    id: 47,
    name: "Priyanka Sharma",
    role: "Sales",
    roleId: 4,
  },
  {
    id: 48,
    name: "Rajat Verma",
    role: "Operation",
    roleId: 3,
  },
  {
    id: 49,
    name: "Anu Khanna",
    role: "Maintenance",
    roleId: 1,
  },
  {
    id: 50,
    name: "Sumit Dutta",
    role: "Stakes",
    roleId: 6,
  },
];
